import api from './api';

// Register new user
export const registerUser = async (userData) => {
  return api.post('/auth/register', userData);
};

// Login user
export const loginUser = async (credentials) => {

  const response = await api.post('/auth/login', credentials);
  
  if (response.access_token) {
    // Store tokens in localStorage
    localStorage.setItem('token', response.access_token);
    localStorage.setItem('refreshToken', response.access_token);
  }
  
  return response;
};




// Logout user
export const logoutUser = async () => {
  try {
    // Call logout endpoint to invalidate token on server
    await api.post('/auth/logout');
  } catch (error) {
    console.error('Error during logout:', error);
  } finally {
    // Clear local storage regardless of server response
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  }
};

// Get current user information
export const getCurrentUser = async () => {
  return api.get('/auth/me');
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

// Reset password request
export const requestPasswordReset = async (email) => {
  return api.post('/auth/reset-password-request', { email });
};

// Reset password with token
export const resetPassword = async (token, newPassword) => {
  return api.post('/auth/reset-password', { token, newPassword });
};

export const setAuthToken = async (token) => {
  localStorage.setItem("token", token);
}

export default {
  registerUser,
  loginUser,
  logoutUser,
  getCurrentUser,
  isAuthenticated,
  requestPasswordReset,
  resetPassword,
  setAuthToken
};